export const OFFER_SUMMARY_CHANGED = "Charisma.Leasing.PublishedLanguage.Events.LeasingOffer.OfferSummaryChanged";
